import { render, staticRenderFns } from "./JwKechengModal.vue?vue&type=template&id=08fe04e1&scoped=true"
import script from "./JwKechengModal.vue?vue&type=script&lang=js"
export * from "./JwKechengModal.vue?vue&type=script&lang=js"
import style0 from "./JwKechengModal.vue?vue&type=style&index=0&id=08fe04e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fe04e1",
  null
  
)

export default component.exports